import * as React from "react";
import { useLocation } from "@grandvisionhq/frk-routing";
import Link from "../../Link/Link/Link.js";
const RouterLink = (props) => {
  const { push } = useLocation();
  const onClickHandler = (e) => {
    if (props?.href) {
      e?.preventDefault();
      push(props?.href);
    }
    props?.onClick?.(e);
  };
  return /* @__PURE__ */ React.createElement(Link, { ...props, onClick: onClickHandler });
};
export {
  RouterLink as default
};
//# sourceMappingURL=RouterLink.js.map
